import React, { useState, useRef } from "react";
import { useUploader } from "@utils";
import { useBluelagoon } from "@bluelagoon";
import { toast } from "sonner";

export default function DesignSystemBrandExtract({ onDesignExtracted }) {
    const [imageUrl, setImageUrl] = useState(null);
    const [preview, setPreview] = useState(null);
    const fileRef = useRef(null);

    const { call: analyzeImage, isLoading: analyzing } = useBluelagoon({ method: "analyzeDesignFromImage" });

    const { uploadFiles, loading: uploading } = useUploader({
        isPublic: true,
        onFileUpload: ({ permanentUrl, key, file }) => {
            setImageUrl(permanentUrl || key);
            setPreview(URL.createObjectURL(file));
        },
    });

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        uploadFiles([file]);
    };

    const handleExtract = async () => {
        if (!imageUrl) return;
        const res = await analyzeImage({ imageUrl });
        if (res?.data?.error || res?.error) {
            toast.error(res?.data?.error || res?.error);
            return;
        }
        const config = res?.data?.config || res?.config;
        if (config) {
            onDesignExtracted(config);
            toast.success("Design extracted from image");
        }
    };

    return (
        <div>
            <label className="text-sm font-medium">Extract from Brand Image</label>
            <p className="text-xs text-muted-foreground mb-1">Upload a brand image to auto-generate colors and typography with AI</p>
            <div className="flex items-center gap-3">
                <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/svg+xml" onChange={handleFileChange} className="hidden" />
                <button type="button" onClick={() => fileRef.current?.click()} disabled={uploading} className="px-3 py-1.5 text-sm border border-input rounded-md hover:bg-accent">
                    {uploading ? "Uploading..." : "Upload Image"}
                </button>
                {preview && <img src={preview} alt="Brand" className="h-10 w-10 object-contain rounded border border-input" />}
                {imageUrl && (
                    <button type="button" onClick={handleExtract} disabled={analyzing} className="px-3 py-1.5 text-sm font-medium bg-primary text-primary-foreground rounded-md hover:bg-primary/90 disabled:opacity-50">
                        {analyzing ? "Extracting..." : "Extract Colors"}
                    </button>
                )}
            </div>
        </div>
    );
}
